import { filter, pluck } from 'ramda'
import { createSchemaBasedConstructor } from './create-typed-constructor'

const Level = createSchemaBasedConstructor('Level')

/*
 * Return all the levels for the named Ordinal
 * @sig levelIdsForOrdinal :: OrdinalId -> [LevelId]
 */
Level.getLevelsForOrdinal = (ordinalId, levels) => filter(l => l.ordinalId === ordinalId, levels)

/*
 * Return all the levelIds for the named Ordinal
 * @sig levelIdsForOrdinal :: OrdinalId -> [LevelId]
 */
Level.getLevelIdsForOrdinal = (ordinalId, levels) => {
    const levelsForOrdinal = Level.getLevelsForOrdinal(ordinalId, levels)
    return pluck('id', levelsForOrdinal)
}

export default Level
